// Action types
const GET_USERS = "spirit/users/GET_USERS";
const SET_USERS_PAGINATE = "spirit/users/SET_USERS_PAGINATE";
const SEARCH_USERS_INPUT = "spirit/users/SEARCH_USERS_INPUT";
const FILTER_USERS_SELECT = "spirit/users/FILTER_USERS_SELECT";
const GET_CAMPUSES = "spirit/users/GET_CAMPUSES";
const GET_ALL_CAMPUSES = "spirit/users/GET_ALL_CAMPUSES";
const GET_ALL_PROFILES = "spirit/users/GET_ALL_PROFILES";

// InitialState
export const initialState = {
  users: [],
  usersPaginate: [],
  allUsers: [],
  searchValue: "",
  selectedStatus: { type: "ALL", title: "Todos" },
  campuses: [],
  allCampuses: [],
  allProfiles: [],
};

// Reducers
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        users: action.info,
        usersPaginate: action.info.slice(0, 50),
        allUsers: action.info,
        searchValue: "",
      };
    case SET_USERS_PAGINATE:
      return {
        ...state,
        usersPaginate: action.info,
        searchValue: "",
      };
    case SEARCH_USERS_INPUT:
      return {
        ...state,
        users: action.info.list,
        usersPaginate: action.info.list.slice(0, 50),
        searchValue: action.info.value,
      };
    case FILTER_USERS_SELECT:
      let filter = [];
      if (action.info.type === "ALL") {
        filter = state.allUsers;
      } else if (action.info.type === "PENDING") {
        filter = state.allUsers.filter(
          (user) => user.status !== "CONFIRMED" && user.status !== "BLOCKED"
        );
      } else {
        filter = state.allUsers.filter(
          (user) => user.status === action.info.type
        );
      }

      return {
        ...state,
        users: filter,
        usersPaginate: filter.slice(0, 50),
        selectedStatus: action.info,
        searchValue: "",
      };
    case GET_CAMPUSES:
      return {
        ...state,
        campuses: action.info,
      };
    case GET_ALL_CAMPUSES:
      return {
        ...state,
        allCampuses: action.info.filter((item) => item.name && item.value),
      };
    case GET_ALL_PROFILES:
      return {
        ...state,
        allProfiles: action.info,
      };
    default:
      return state;
  }
};

// Action Creators
export const getUsers = (info) => ({
  type: GET_USERS,
  info,
});

export const setUsersPaginate = (info) => ({
  type: SET_USERS_PAGINATE,
  info,
});

export const searchUsersInput = (info) => ({
  type: SEARCH_USERS_INPUT,
  info,
});

export const setFilterUsers = (info) => ({
  type: FILTER_USERS_SELECT,
  info,
});

export const getCampuses = (info) => ({
  type: GET_CAMPUSES,
  info,
});

export const getAllCampuses = (info) => ({
  type: GET_ALL_CAMPUSES,
  info,
});

export const getAllProfiles = (info) => ({
  type: GET_ALL_PROFILES,
  info,
});
